// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"uL-z","upvoteIcon":"vL-z","downvoteIcon":"wL-z","feedbackIcon":"xL-z"};